import React, { useState, useEffect, useRef, useCallback } from "react";

const NewMultiSelectDropdown = ({
  options = [], // All available employees
  selectedOptions = [], // Selected by user or pre-filled in edit
  handleChangeSelect = () => {}, // Function to toggle selection
  assignedOptions = [], // Already assigned employees (disabled)
  labelName = "",
  moreValue ="",
  searchText = "",
  setSearchText = () => {},
  handleLoadMore = () => {},
  hasMore = false,
  loading = false,
  showastrict = false,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const listRef = useRef(null);

  // 🔹 Close dropdown on outside click or escape key
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    const handleEscape = (e) => e.key === "Escape" && setIsDropdownOpen(false);

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  // 🔹 Infinite scroll logic
  const handleScroll = useCallback(() => {
    const el = listRef.current;
    if (!el || loading || !hasMore) return;

    const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    // console.log("Scroll distance:", distanceFromBottom);

    if (distanceFromBottom < 50) {
      handleLoadMore();
    }
  }, [loading, hasMore, handleLoadMore]);

  useEffect(() => {
    const el = listRef.current;
    if (el && isDropdownOpen) {
      el.addEventListener("scroll", handleScroll);
      return () => el.removeEventListener("scroll", handleScroll);
    }
  }, [isDropdownOpen, handleScroll]);

  // 🔹 Check if option is already assigned (disabled)
  const isAssigned = (option) =>
    assignedOptions?.some((assigned) => assigned?.value === option.value);

  // 🔹 Combine selected + assigned for display text
  const allLabels = new Set();
  selectedOptions?.forEach((opt) => allLabels.add(opt.label));
  assignedOptions?.forEach((opt) => allLabels.add(opt.label));

  const labelsArray = Array.from(allLabels);
  // const selectedText = labelsArray.length > moreValue
  //   ? `${labelsArray.slice(0, moreValue).join(", ")} + ${labelsArray.length - moreValue} more`
  //   : labelsArray.join(", ") || "Select options";

  const selectedText = labelsArray.length > 0
  ? `${labelsArray.length} Selected`
  : "Select options";

  // 🔹 Filter options by search text
  const filteredOptions = options.filter((option) =>
    option?.label?.toLowerCase().includes(searchText.toLowerCase())
  );

  // 🔹 Remove duplicates
  const uniqueOptions = Array.from(
    new Map(filteredOptions.map((item) => [item.value, item])).values()
  );

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      {/* Label */}
      {labelName && (
        <label className="addInput-label">
          {labelName} {showastrict && <span className="text-danger">*</span>}
        </label>
      )}

      {/* Selected summary */}
      <div
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        className="addInputText-lable form-select multiselects-input"
        style={{ cursor: "pointer" }}
      >
        {selectedText}
      </div>

      {/* Dropdown content */}
      {isDropdownOpen && (
        <div
          className="multidropdownopen"
          // style={{
          //   border: "1px solid #ccc",
          //   borderRadius: "4px",
          //   background: "#fff",
          //   marginTop: "5px",
          //   zIndex: 1000,
          //   position: "absolute",
          //   width: "100%",
          // }}
        >
          {/* Search box (sticky) */}
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search..."
            style={{
              width: "100%",
              padding: "8px 10px",
              border: "none",
              borderBottom: "1px solid #ddd",
              position: "sticky",
              top: 0,
              background: "#fff",
              zIndex: 2,
               
            }}
          />

          {/* Options list (scrollable area) */}
          <ul
            ref={listRef}
            style={{
              listStyle: "none",
              margin: 0,
              padding: "10px",
              maxHeight: "150px",
              overflowY: "auto",
            }}
          >
            {uniqueOptions.length > 0 ? (
              uniqueOptions.map((option) => {
                const assigned = isAssigned(option);
                const checked =
                  assigned ||
                  selectedOptions.some(
                    (item) => item.value === option.value
                  );

                return (
                  <li key={option.value} style={{ marginBottom: "5px" }}>
                    <label
                      style={{
                        cursor: assigned ? "not-allowed" : "pointer",
                        color: assigned ? "#888" : "#000",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={checked}
                        disabled={assigned}
                        onChange={() => !assigned && handleChangeSelect(option)}
                        style={{ marginRight: "8px" }}
                      />
                      {option.label}
                    </label>
                  </li>
                );
              })
            ) : (
              <li style={{ textAlign: "center", color: "#888" }}>
                No results found
              </li>
            )}
          </ul>

          {/* Loader or end message */}
          <div
            style={{
              textAlign: "center",
              padding: "8px",
              fontSize: "13px",
              color: "#666",
            }}
          >
            {loading && <span>Loading...</span>}
            {!loading && !hasMore && uniqueOptions.length > 0 && (
              <span>No more results</span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NewMultiSelectDropdown;
